import PageableCollection from '@/backbone/PageableCollection';
import StringCell from '@/backgrid/StringCell';
import { DateCell } from '@/backgrid/MomentCell';
import ButtonCell from '@/backgrid/ButtonCell';
import GridView from '@/views/GridView';
import showModal from '@/util/showModal';
import showErrorMessage from '@/util/showErrorMessage';

import GetCommandPOCsForExpiringContracts from '../../services/GetCommandPOCsForExpiringContracts';
import SendEmailContractExpirationReminder from '../../services/SendEmailContractExpirationReminder';
import ExpiringContractNotificationModal from '../ExpiringContractNotificationModal';

const ExpiringContractGrid = GridView.extend({
  options: {
    pageSize: 25
  },

  initialize() {
    const self = this;

    this.options.columns = [
      {
        name: 'piinSpiin',
        label: 'Contract #',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'contractEndDate',
        label: 'Contract End Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true
      },
      {
        name: 'daysUntilContractEnd',
        label: 'Days Until End of Contract',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true
      },
      {
        name: 'contractVehicleName',
        label: 'Contract Vehicle',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true
      },
      {
        name: 'numberDevices',
        label: 'Number of Devices',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'formattedTotalValue',
        label: 'Total Value of Contract',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true
      },
      {
        name: 'openButton',
        label: '',
        width: 10,
        headerCell: 'custom',
        cell: ButtonCell.extend({
          name() {
            return 'Open';
          },
          onClick(e, model) {
            self.onClickOpen(e, model);
          },
          buttonClass: 'btn-sm btn-outline-primary text-center'
        }),
        editable: false,
        sortable: false
      }
    ];

    this.collection = new PageableCollection(this.model.get('expiringContractsDetails').expiringContracts, {
      pageSize: 10
    });
    this.options.emptyText = 'No Expired Contracts Found';
    GridView.prototype.initialize?.apply(this, this.options);
  },

  async onClickOpen(e, model) {
    if (e?.type) e.preventDefault();

    const pocs = await GetCommandPOCsForExpiringContracts(model.get('piinSpiin'))
    model.set('commandPOCs', pocs.commandPOCs)
    
    const formData = await showModal({
      title: 'Expiring Contract Notification',
      view: new ExpiringContractNotificationModal({
        isReadOnly: false,
        model,
        orderFormTypes: this.model.get('orderFormTypes')
      }),
      dialogClasses: 'modal-lg'
    })

    try {
      await SendEmailContractExpirationReminder(formData)
    } catch (err) {
      this.showSendReminderError(err)
    }
  },

  showSendReminderError(err) {
    showErrorMessage({
      errorCode: 'reminderError',
      errorTitle: 'Notification Error',
      errorMessage: 'An error occurred while sending expiring contract reminders. Please try again. If this issue persists, please contact an administrator.'
    });
  },
});

export default ExpiringContractGrid;
